
import React from 'react';
import { NikoFacilityOrderNewFlowInventoryCalculationProcessModalTemplate } from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowInventoryCalculationProcessModalStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowInventoryCalculationProcessModalStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowInventoryCalculationProcessModalStore')
@observer
class NikoFacilityOrderNewFlowInventoryCalculationProcessModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowInventoryCalculationProcessModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowInventoryCalculationProcessModal;
